@if (isWaitingForUpdate || !wealthTokenExist) {
  <app-spinner></app-spinner>
} @else {
  @if (shouldEnterPassword | async) {
    <app-enter-password></app-enter-password>
  }
  @if (isInit) {
    <div class="surface-back">
      <router-outlet></router-outlet>
    </div>
  }
}
